import { ExtendsMainComponent } from '../extends/extends-main.component';

import { ResetPasswordComponent } from './reset-password.component';
import { Compiler, Component, NgModule, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MessageModalComponent } from '../message-modal/message-modal.component';
import { WaitModalComponent } from '../wait-modal/wait-modal.component';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { Router } from '@angular/router';

import { ResetPasswordService } from '../../service/reset-password.service';
import { TokenManager } from '../../service/web-api.service';
import { WebApiService } from '../../service/web-api.service';
import { AuthService } from '../../service/auth.service';
import { CheckItemService, CheckItemIn } from '../../service/checkItem.service';

import { environment } from '../../../environments/environment';
import { filter, mergeMap } from 'rxjs/operators';

declare let gtag: any; // グローバル変数gtagを解決

export class ResetPasswordMainComponent extends ExtendsMainComponent {

  private waitModal: WaitModalComponent;
  private messageModal: MessageModalComponent;
  private confirmModal: ConfirmModalComponent;

  private resetPasswordComponent: ResetPasswordComponent;
  private resetPasswordService: ResetPasswordService;
  private checkItemService: CheckItemService;
  private authService: AuthService;

  private checkItemIn: CheckItemIn;

  // タイトルロゴ
  public dispZ0001: string;

  // 画面項目定義
  public email: string;
  public password: string;
  public confirmPassword: string;
  public messages: any;

  public passDispType: string;

  // パスワード充足チェックパターン
  public patternCount;
  public patternSmallChar;
  public patternLargeChar;
  public patternNum;
  public patternSymbol;

  // パスワード充足チェック結果
  public countResult: boolean;
  public smallCharResult: boolean;
  public largeCharResult: boolean;
  public numResult: boolean;
  public symbolResult: boolean;
  public haveEnoughConditions: boolean;

  init(_resetPasswordComponent: ResetPasswordComponent, _resetPasswordService: ResetPasswordService,
    _checkItemService: CheckItemService, _authService: AuthService, _waitModal: WaitModalComponent,
    _messageModal: MessageModalComponent, _confirmModal: ConfirmModalComponent) {

    this.config();

    this.resetPasswordService = _resetPasswordService;
    this.checkItemService = _checkItemService;
    this.waitModal = _waitModal;
    this.messageModal = _messageModal;
    this.confirmModal = _confirmModal;
    this.authService = _authService;

    this.resetPasswordComponent = _resetPasswordComponent;
    this.dispZ0001 = this.resetPasswordComponent.dispZ0001;

    this.email = this.resetPasswordComponent.email;
    this.password = this.resetPasswordComponent.password;
    this.confirmPassword = this.resetPasswordComponent.confirmPassword;
    this.messages = [];

    this.passDispType = 'password';

    this.patternCount = new RegExp('^.{8,64}$');
    this.patternSmallChar = new RegExp('.*[a-z]+.*');
    this.patternLargeChar = new RegExp('.*[A-Z]+.*');
    this.patternNum = new RegExp('.*[0-9]+.*');
    // 文字列リテラルの場合でエスケープするためには"\(バックスラッシュ)"が2つ必要
    this.patternSymbol = new RegExp('.*[@#\\$%\\^&\\*\\-_\\+=\\[\\]\\{\\}\\|\\:\',\\?\\/`~\\"\\(\\);\\.!]+.*');
  }

  /**
   * 次へ
   *
   * @param checkItem チェック対象項目
   */
  next(checkItem: string[]) {

    this.email = this.email.toLowerCase().trim();

    // パラメータ設定
    this.checkItemIn = new CheckItemIn();
    for (const item of checkItem) {
      switch (item) {
        case 'mailAddress':
          this.checkItemIn.mailAddress = this.email;
          break;
        case 'password':
          this.checkItemIn.password = this.password;
          this.checkItemIn.confirmPassword = this.confirmPassword;
          this.checkItemIn.mailAddress = this.email;
          break;
      }
    }
    this.waitModal.showModal();

    // チェック処理
    this.checkItemService.execAuthCheckItem(this.checkItemIn).subscribe(result => {
      this.waitModal.hideModal();

      if (result == null) {
        this.messages = [];

        // 引継ぎ項目
        this.resetPasswordComponent.email = this.email;
        this.resetPasswordComponent.password = this.password;
        this.resetPasswordComponent.confirmPassword = this.confirmPassword;
        this.resetPasswordComponent.pageNo++;

        // 画面切り替え
        this.resetPasswordComponent.directInjection();

      } else {
        this.messages = result;
        this.scrollError();
      }
    });
  }

  /**
   * イベント：戻る
   */
  back() {
    // 引継ぎ項目
    this.resetPasswordComponent.pageNo--;

    // 画面切り替え
    this.resetPasswordComponent.directInjection();
  }

  /**
   * イベント：認証画面遷移
   */
  toSignIn() {
    this.resetPasswordComponent.router.navigate(['sign-in']);
  }

  /**
   * イベント：メール送信
   *
   * @param isNext 次ページ遷移　true:遷移/false:遷移なし
   * @param isSeq true:認証URLリンク先からパスワードリセット継続
   */
  sendMail(isNext: boolean, isSeq: boolean) {
    this.messages = [];
    this.waitModal.showModal();

    let pageNo = null;
    if (isSeq) {
      pageNo = this.resetPasswordComponent.pageNo + 2;

    }

    this.email = this.email.toLowerCase().trim();
    this.resetPasswordService.execAuthSendMail(this.email, this.resetPasswordComponent.SCREEN_ID,
      pageNo, this.generateNextParameter()).subscribe(result => {
        this.waitModal.hideModal();
        if (result == null) {
          this.messages = [];
          if (isNext) {
            this.next([]);
          }
        } else {
          this.messages = result;
          this.scrollError();
        }
      });
  }

  /**
   * イベント：メール認証チェック
   *
   */
  checkMail() {
    this.messages = [];
    this.waitModal.showModal();

    this.resetPasswordService.execAuthCheckMail().subscribe(result => {
      this.waitModal.hideModal();
      if (result == null) {
        this.messages = [];
        this.next([]);
      } else {
        this.messages = result;
        this.scrollError();
      }
    });
  }

  /**
   * パスワードリセット
   */
  resetPassword() {
    this.resetPasswordService.execAuthShouldResetResource()
      .subscribe(result => {
        if (result.shouldResetResource) {
          let message = '';
          this.resetPasswordComponent.translateService.get('DELETE_RESOURCE_CONFIRMATION').subscribe((res: string) => {
            message = res;
          });
          this.confirmModal.showConfirmModal(message, 'OK').pipe(
            filter(res => res)
          ).subscribe(() => this.resetPasswordMain());
        } else {
          this.resetPasswordMain();
        }
      }, error => {
        this.resetPasswordComponent.router.navigate(['/error', 500]);
        this.scrollError();
      });
  }

  /**
  * パスワードの表示・非表示を切り替える
  */
  switchPassDisp() {
    // 表示する
    if (this.passDispType === 'password') {
      this.passDispType = 'text';
      return;
    }
    // 非表示にする
    if (this.passDispType === 'text') {
      this.passDispType = 'password';
      return;
    }
  }


  /**
   * 設定されたパスワードをチェックする
   */
  passwordCheck() {
    this.countResult = this.patternCount.test(this.password);
    this.smallCharResult = this.patternSmallChar.test(this.password);
    this.largeCharResult = this.patternLargeChar.test(this.password);
    this.numResult = this.patternNum.test(this.password);
    this.symbolResult = this.patternSymbol.test(this.password);

    let conditionCount = 0;

    if (this.smallCharResult) {
      conditionCount++;
    }
    if (this.largeCharResult) {
      conditionCount++;
    }
    if (this.numResult) {
      conditionCount++;
    }
    if (this.symbolResult) {
      conditionCount++;
    }
    if (conditionCount >= 2) {
      this.haveEnoughConditions = true;
    } else {
      this.haveEnoughConditions = false;
    }

  }

  private resetPasswordMain() {
    this.messages = [];
    this.waitModal.showModal();
    this.resetPasswordService.execAuthResetPassword(this.email, this.password, this.confirmPassword)
      .pipe(
        filter(result => {
          this.waitModal.hideModal();
          this.messages = result;
          return result === null;
        })
      ).pipe(
        mergeMap(
          result => {
            let message = '';
            this.resetPasswordComponent.translateService.get('PASSWORD_RESET_SENTENCE').subscribe((res: string) => {
              message = res;
            });
            return this.messageModal.showMessageModal(message);
          })
      ).subscribe(messagResult => {
        // GAで集計する
        gtag('event', 'reset_password');
        this.resetPasswordComponent.router.navigate(['sign-in']);
      },
        error => {
          this.resetPasswordComponent.router.navigate(['/error', 500]);
          this.scrollError();
        }
      );
  }

  /**
   * 引継ぎ用情報をJson形式で作成します。
   */
  private generateNextParameter(): string {

    // 引継ぎ情報objectを作成
    const jsonObj = {
      email: this.email,
      password: this.password,
      confirm_password: this.confirmPassword,
    };

    // objectをjsonにパース
    return JSON.stringify(jsonObj);
  }
}
